import { render, staticRenderFns } from "./GuideDialog.vue?vue&type=template&id=96d9c4fc&scoped=true&"
import script from "./GuideDialog.vue?vue&type=script&lang=ts&"
export * from "./GuideDialog.vue?vue&type=script&lang=ts&"
import style0 from "./GuideDialog.vue?vue&type=style&index=0&id=96d9c4fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d9c4fc",
  null
  
)

export default component.exports